
export class wrapTable {
  constructor() {
    const tables = document.querySelectorAll(".article_content table")

    tables.forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains("table-wrap")) {
        return
      }

      const wrapper = document.createElement("div")
      wrapper.className = "table-wrap"
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    })
  }
}
